import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import httpClient from "../../HTTPService";
import noImage from "../../assets/noimage.jpg"
import moment from "moment";
import { Tooltip as ReactTooltip } from "react-tooltip";

function WithdrawListView() {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');
    // const type = queryParams.get('type');

    const [accouuntDetaila, setaccountDetails] = useState()
    const [accountDetails, setAccouuntDetails] = useState()
    const navigate = useNavigate()
    const [withdrawalList, setWithdrawalList] = useState([])
    const [fundingDatalist, setfundingDatalist] = useState([])
    const [uplineData, setUplineData] = useState([])

    const [total_commission, settotal_commission] = useState(0)
    const [currentsuerview, setCurrenuserview] = useState('WITH_DRAWAL')


    // The substituted value will be contained in the result variable
    const result = id?.match(/\d+(\.\d+)?/g);
    // console.log(result[0] ,'number result>>>>')
    // console.log(id, 'user id.>>>')
    useEffect(() => {

        if (location?.search?.includes('history')) {
            getwithdrawalListData()

        } else {
            getfundingDetails()
            console?.log('not history exit....')
        }
        // console.log(type ,id,'typesdsss')
        getMembersDetailsView()
        // getfundingDetails()
        getUplineData()
    }, [])
    const getwithdrawalListData = async () => {
        try {
            const result = await httpClient.post('/admin/members-withdraw-list', { user_id: id?.match(/\d+(\.\d+)?/g)[0] }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            console.log(result?.data.data, 'fjelkfjdkf')
            if (result.status === 200) {
                // console.log(result.data ,'withdrawl list...')
                setWithdrawalList(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    const getfundingDetails = async () => {
        try {
            const result = await httpClient.post('/admin/members-funding-details', { user_id: id?.match(/\d+(\.\d+)?/g)[0] }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            console.log(result?.data.data, 'fjelkfjdkf')
            if (result.status === 200) {
                // console.log(result.data ,'withdrawl list...')
                setfundingDatalist(result?.data?.data)
                calcualte_totalpayamount(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    const getMembersDetailsView = async () => {
        try {
            const result = await httpClient.post('/admin/members-view', { id: id?.match(/\d+(\.\d+)?/g)[0] }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            console.log(result?.data.data, 'fjelkfjdkf')
            if (result.status === 200) {
                console.log(result.data?.data, 'data..')
                setaccountDetails(result.data?.data)
                setAccouuntDetails(result.data?.member_details)
                // setBusinessProfiles(result.data?.profiles)
                // setBankdetails(result.data?.bank_accounts[0])
                // setmemberlist(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    const getUplineData = async () => {
        try {
            const result = await httpClient.post('/admin/depth-upline-member-list', {

                user_id: id?.match(/\d+(\.\d+)?/g)[0],

            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                let week_arr = []
                console.log(result.data.data, 'data..')
                // setTotalCount(result?.data.total_count)
                setUplineData(result?.data?.data)

                // setweeklyData(result?.data?.weekly_report_data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    function calcualte_totalpayamount(_input) {
        let TOTAL = 0;

        _input?.forEach(item => {
            TOTAL += item?.commission ? parseFloat(item?.commission) : 0;

        });
        settotal_commission(TOTAL)
    }
    return (
        <>
            <div className="header-back"
                onClick={() => navigate('/member', {
                    state: {
                        backpagi: location?.state?.paginationState
                    }
                })}
            >
                <div></div>
                <div className="back-button">
                    <i class="fa fa-arrow-left back-arrow-button"
                        // className="back-arrow-button"
                        aria-hidden="true"></i>
                </div>

            </div>
            <div style={{
                display: 'flex',
                width: 400,
                display: 'flex',
                justifyContent: 'space-between'
                // flexDirection:'column'
            }}>
                {/* <h5>Income Page</h5> */}
                {/* <h5>Total Earning - {accountDetails?.depth_1_total_commission + accountDetails?.depth_2_total_commission}</h5> */}

            </div>

            <div className="row">

                <div className="card col-md-5">

                    <h5>Profile Details</h5>

                    {/* <div className="acc-profile-image-section ">
                                       
                                       <p>Profile Image :</p>
                                       
                                       <div className="acc-details-image">
                                           <div className="image-container">
                                               <img
                                                   className="image-acc-details"
                                                   src={accouuntDetaila?.profile_photo_url !== null ?
               
                                                       accouuntDetaila?.profile_photo_url : noImage
                                                   }></img>
                                           </div>
               
                                           <div>
               
                                               <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                                           </div>
                                       </div>
                                   </div> */}


                    <div className="account-details" style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <div>
                            <p>Name : {accouuntDetaila?.name} </p>
                            {/* <p className="ml-2"></p> */}
                        </div>



                        <div>

                            <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                        </div>



                    </div>
                    {/* <div className="account-details">
                                       <p>Email : </p>
                                       <p className="ml-2"> {accouuntDetaila?.email}</p>
                                   </div> */}
                    <div className="account-details">
                        <p>Phone : </p>
                        <p className="ml-2">{accouuntDetaila?.phone}</p>
                    </div>
                    <div className="account-details">
                        <p>Member Id : </p>
                        <p className="ml-2">{accouuntDetaila?.user_referral_code}</p>
                    </div>
                    <div className="account-details">
                        <p>Joining Date : </p>
                        <p className="ml-2">{accouuntDetaila?.joing_date !== null ?
                            moment(accouuntDetaila?.joing_date).format('DD-MM-YYYY') : null}</p>
                    </div>
                    <div className="account-details">
                        <p>Refered By : </p>
                        <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                            accouuntDetaila?.referral_code : null}</p>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <p>Depth Line : <span style={{ color: 'green' }}> {uplineData?.length} </span></p>

                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">Check UP-line</button>

                    </div>
                    <div className="addres-account-details">
                        <p>Address:
                            {`${accouuntDetaila?.state !== null ? `${accouuntDetaila?.state?.name},` : ''}
                                        ${accouuntDetaila?.district !== null ? `${accouuntDetaila?.district?.district_name},` : ''} 
                                        ${accouuntDetaila?.city !== null ? `${accouuntDetaila?.city},` : ''}
                                        ${accouuntDetaila?.pin_code !== null ? `${accouuntDetaila?.pin_code}` : ''}`}
                        </p>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: 'row'
                    }}>
                        <p>Position : </p>
                        <button type="button"
                            style={{
                                backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red',
                                border: 'none',
                                fontSize: 12,
                                color: 'white'
                            }}
                            data-toggle="modal" data-target=".bd-example-modal-lg">{accouuntDetaila?.position !== null ?
                                accouuntDetaila?.position : null}</button>

                        {/* <h6 className="ml-2 user-position" style={{
                                           backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red'
                                       }}
               
                                       >{accouuntDetaila?.position !== null ?
                                           accouuntDetaila?.position : null}</h6> */}
                    </div>
                    <div className="account-details">
                        <p>Become Active On : {moment(accountDetails?.member_active_date).format('DD-MM-YYYY')}</p>
                        {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                                                accouuntDetaila?.referral_code : null}</p> */}
                    </div>
                    <div className="account-details">
                        <p>Last Open On :  {accountDetails?.last_login && moment(accountDetails?.last_login).format('DD-MM-YYYY')}  {accountDetails?.last_login && moment(accountDetails?.last_login).format('LT')}</p>

                        {/* <p>Last Active On : {
                          
                          moment(accountDetails?.last_login).format('DD-MM-YYYY')}  {moment(accountDetails?.last_login).format('LT')
                          
                          }</p> */}
                        {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                                                accouuntDetaila?.referral_code : null}</p> */}
                    </div>

                </div>
                <div className=" col-md-7"
                    style={{
                        // marginLeft:20
                    }}
                >
                    <div className="row">
                        <div className="card income-view-box col-md-9" style={{
                            marginLeft: 10
                        }}>
                            <p style={{
                                padding: 0,
                                margin: 0
                            }}>Both Total Income - Rs. {Number(Number(accountDetails?.depth_1_total_commission) + Number(accountDetails?.depth_2_total_commission))?.toFixed(2)}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="card income-view-box col-md-9" style={{
                            marginLeft: 10
                        }}>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            }}>
                                <p style={{
                                    fontSize: 14
                                }}>Direct member income:</p>
                                <p style={{
                                    fontSize: 14
                                }}>Rs {Number(accountDetails?.depth_1_total_commission)?.toFixed(2)}</p>
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            }}>
                                <p style={{
                                    fontSize: 14
                                }}>Depth 2 member income:</p>
                                <p style={{
                                    fontSize: 14
                                }}>Rs {Number(accountDetails?.depth_2_total_commission)?.toFixed(2)}</p>
                            </div>
                            <div style={{
                                width: '100%',
                                backgroundColor: '#FFFFFF',
                                height: 2,

                            }}></div>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            }}>
                                <p style={{
                                    fontSize: 14
                                }}>Both total income:</p>
                                <p style={{
                                    fontSize: 14
                                }}>Rs {Number(Number(accountDetails?.depth_1_total_commission) + Number(accountDetails?.depth_2_total_commission))?.toFixed(2)}</p>
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            }}>
                                <p style={{
                                    fontSize: 14
                                }}>Withdrawl Amount:</p>
                                <p style={{
                                    fontSize: 14
                                }}>Rs {Number(accountDetails?.withdraw_amount)?.toFixed(2)}</p>
                            </div>
                            <div style={{
                                width: '100%',
                                backgroundColor: '#FFFFFF',
                                height: 2,

                            }}></div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            }}>
                                <p style={{
                                    fontSize: 14
                                }}>Balance Amount:</p>
                                <p style={{
                                    fontSize: 14
                                }}>Rs {Number(accountDetails?.current_balance)?.toFixed(2)}</p>
                            </div>

                        </div>
                    </div>
                    <h5>  {location?.search?.includes('history') ? 'Withdraw History' : 'Funding History'}</h5>
                    {
                        location?.search?.includes('history') && (
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>SL NO</th>
                                            <th>A/C Holder Name</th>

                                            <th>Date & Time</th>
                                            <th>To Account</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            withdrawalList.map((item, index) => {
                                                // const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                                return (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {item.user_name}

                                                        </td>

                                                        <td>
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}>
                                                                <p style={{
                                                                    margin: 0,
                                                                    padding: 0
                                                                }}> {moment(item.approved_date).format('DD/MM/YYYY')}</p>
                                                                <p style={{
                                                                    margin: 0,
                                                                    padding: 0
                                                                }}> {moment(item.approved_date).format('LT')}</p>
                                                            </div>

                                                        </td>
                                                        <td>{item.account}</td>
                                                        <td>
                                                            {item?.amount}
                                                            {/* <p style={{
                                                                color: item?.current_status == 'Cancelled' ? 'red' : 'green'
                                                            }}>{item?.current_status} </p> */}
                                                        </td>
                                                    </tr>
                                                )
                                            })

                                        }

                                    </tbody>
                                </table>
                                <div className='nodata-found-div'>
                                    {
                                        withdrawalList?.length == 0 ?
                                            <p>No Data Found</p>
                                            //  <img 
                                            //  className='table-image'
                                            //  src={require('../../assets/OIP.png')}/>
                                            : null
                                    }
                                </div>
                            </div>
                        )
                    }
                    {
                        location?.search?.includes('funding') && (
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>S.N</th>
                                            <th>Date</th>
                                            <th>Paid</th>

                                            <th>Remark</th>
                                            <th>Category</th>
                                            <th>Sub-Category</th>
                                            <th>
                                                {/* <div> */}

                                                <p style={{
                                                    padding: 0,
                                                    margin: 0
                                                }}> Commission</p>
                                                <p style={{
                                                    padding: 0,
                                                    margin: 0
                                                }}>D-1 = {accountDetails?.depth_1_per_member_commission}%  D-2 = {accountDetails?.depth_2_per_member_commission}%</p>
                                                {/* </div> */}
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            fundingDatalist.map((item, index) => {
                                                // const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                                return (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        {/* <td>{index + 1}</td> */}
                                                        <td>
                                                            {moment(item.date).format('DD/MM/YYYY')}

                                                        </td>

                                                        <td>{item?.paid_amount}</td>
                                                        <td style={{
                                                            display: 'flex',
                                                            flexDirection: 'column'
                                                        }}>
                                                            <p>{
                                                                item?.commission_type == 'Added Profile' ? 'Profile Added' : 'Service Used'

                                                            }</p>
                                                            <ReactTooltip
                                                                id={item?.user_referral_code}
                                                                place="bottom"
                                                                render={() => (
                                                                    <div style={{
                                                                        padding: 0,
                                                                        margin: 0,
                                                                    }}>
                                                                        <p style={{
                                                                            padding: 0,
                                                                            margin: 0
                                                                        }}>
                                                                            {item?.user_name || ''}
                                                                        </p>

                                                                    </div>
                                                                )}
                                                            />
                                                            {/* <ReactTooltip
                                                            id={item?.phone}
                                                            place='bottom'
                                                            content={item?.referred_by != [] ? item?.referred_by?.name : ''}

                                                        />
                                                        <p data-tooltip-id={item?.phone}></p> */}
                                                            <div data-tooltip-id={item?.user_referral_code} >
                                                                {item?.user_referral_code || ''}
                                                            </div>


                                                        </td>
                                                        <td>
                                                            <p>{item?.category}</p>
                                                        </td>
                                                        <td>
                                                            <p>{item?.sub_category}</p>
                                                        </td>
                                                        <td>

                                                            {item?.member_level}={item?.commission_percentage} Rs:{item?.commission}
                                                        </td>
                                                    </tr>
                                                )
                                            })

                                        }

                                    </tbody>
                                </table>
                                <div className='nodata-found-div'>
                                    {
                                        fundingDatalist?.length == 0 ?
                                            <p>No Data Found</p>
                                            //  <img 
                                            //  className='table-image'
                                            //  src={require('../../assets/OIP.png')}/>
                                            : null
                                    }
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="table-responsive">
                                            <table class="table" style={{
                                                backgroundColor: '#FFFFFF'
                                            }}>
                                                <tbody>
                                                    <tr>
                                                        {/* <th className="col-1"></th> */}
                                                        <td className="col-1"  > </td>
                                                        <td className="col-1"  >     </td>
                                                        <td className="col-1" style={{
                                                            textAlign: 'start'
                                                        }} >


                                                        </td>
                                                        {/* <td className="col-1"></td> */}
                                                        <td className="col-1">

                                                        </td>
                                                        <td className="col-1"> </td>
                                                        <td className="col-1"></td>
                                                        <td className="col-1">Total: {total_commission}</td>


                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                </div>

            </div>
            <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content" style={{
                        padding: 20
                    }}>
                        <div class="row">
                            <h5>Up Line Members</h5>
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>SL NO</th>
                                                <th> Member ID</th>
                                                <th>Name</th>
                                                {/* <th>Validity</th>
                <th >Description</th> */}
                                                {/* <th>Discount</th>
                <th>Price</th> */}

                                                <th>Mobile</th>
                                                <th>Address</th>
                                                <th>Joing Date</th>
                                                <th>Depth Line</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                uplineData?.map((item, index) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td>{index + 1}</td>

                                                                <td>{item?.member_code}</td>
                                                                <td>

                                                                      <div style={{ display: 'flex', flexDirection: 'column' }}>

                                    {item?.name}
                                    {item?.active == 1 ?
                                      <span className="ml-2 active_profile_table" style={{
                                        color: 'green'
                                      }}>Active</span>
                                      :
                                      <span className="ml-2 inactive_profile_table" style={{
                                        color: 'red'
                                      }}>Inactive</span>
                                    }
                                  </div>
                                                                </td>
                                                                <td>{item?.phone}</td>
                                                                <td>{item?.address !== null ? item?.address : '--'}</td>
                                                                <td>{moment(item?.joing_date).format('DD-MM-YYYY')}</td>
                                                                <td style={{
                                                                    textAlign:'center',
                                                                    // dis
                                                                }}>{item?.level}</td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }


                                        </tbody>

                                    </table>
                                    <div className='nodata-found-div'>
                                        {
                                            uplineData?.length == 0 ?
                                                <p>No Data Found</p>
                                                //  <img 
                                                //  className='table-image'
                                                //  src={require('../../assets/OIP.png')}/>
                                                : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default WithdrawListView